import React, { useState, useRef } from 'react';

const Popup = ({ onAgree }) => {
  const [agreementAccepted, setAgreementAccepted] = useState(false);
  const [isAgreementScrolled, setIsAgreementScrolled] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [conditions, setConditions] = useState({
    noPriorOffense: false,
    noPendingCharge: false,
    notFelon: false,
    validLicense: false,
    noCDL: false,
    duvalCounty: false,
    noPlea: false,
  });
  const [error, setError] = useState('');
  const agreementRef = useRef(null);

  const handleScroll = () => {
    const element = agreementRef.current;
    if (element) {
      const isScrolledToBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 1;
      setIsAgreementScrolled(isScrolledToBottom);
    }
  };

  const handleAcceptAgreement = () => {
    if (isAgreementScrolled && termsAccepted) {
      setAgreementAccepted(true);
    }
  };

  const handleTermsCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setConditions((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = () => {
    const allChecked = Object.values(conditions).every((value) => value === true);
    if (allChecked) {
      onAgree();
    } else {
      setError('Not eligible for the program');
    }
  };


  /*
  const agreementText = `
                                                                                                                                                      TERMS AND CONDITIONS
                                                                                                                             STATE ATTORNEY’S OFFICE – 4TH JUDICIAL CIRCUIT
DUI First Time Offender Program

CAUTION: These terms and conditions of the DUI First Time Offender Program are intended to outline the Program and are not intended to be legal advice. If you have any questions about your rights, adverse consequences, or the advantages or disadvantages of this program please consult a lawyer.  
INTENT OF PROGRAM: The DUI First Time Offender Program is intended for non-aggravated DUI offenses for offenders with little or no criminal history. The program contains many of the educational components and consequences related to a DUI offense without the resulting criminal conviction for DUI.  
RESULT OF PROGRAM: An eligible offender will be permitted to enter a plea of guilty or no contest to the amended charge of Reckless Driving, and will be placed on probation to complete terms and conditions outlined below.
ELIGIBILITY REQUIREMENTS FOR PROGRAM: This program is designed for eligible first time DUI offenders charged with misdemeanor DUI contrary to Section 316.193, Florida Statutes. No person is entitled to participate in the program, and in its discretion, the State Attorney’s Office may reject any person for consideration if it determines it is warranted under the facts and circumstances. An offender will be ineligible for the program if he or she:
1.Has been charged with a prior alcohol-related or drug-related criminal traffic offense which resulted in an Adjudication of Guilt, a Withhold of Adjudication, or completion of a DUI diversionary program;  
2.Has a pending criminal charge (felony or misdemeanor) or prior felony conviction; 
3.Caused or contributed to the cause of a motor vehicle crash causing property damage or personal injury to another, unless the harmed party supports the defendant pleading to a reduced charge;
4.Was, at the time of the offense, accompanied in the vehicle by a person under 18 years of age;
5.Contemporaneously committed a separate offense involving dangerous driving, such as racing, or speed in excess of 30mph over the posted limit;
6.Did not have a valid driver’s license, or had a license or driving privilege which was canceled, suspended, or revoked;
7.Is not a U.S. citizen;
8.Had a Commercial Driver License (CDL);
9.Had a blood alcohol level of 0.20 or more grams of alcohol per 100 milliliters of blood; or a breath-alcohol level of 0.20 or more grams of alcohol per 210 liters of breath; 
ENTRY INTO PROGRAM: You or your attorney must request a case screening through the SAO website and pay a $100 screening fee before your case is reviewed. Upon completion of the application and payment, the SAO will review your case for the program. 
If the SAO determines you are eligible for the program accepts your application, the SAO will notify you or your attorney. 
You or your attorney must still appear at the next scheduled court date. 

PREREQUISITES PRIOR TO REDUCED PLEA: If you are determined to be eligible and accept entry to the Program, prior to the resolution of your case you must:
•	Register for an approved DUI School. A list of programs can be found at the Florida DHSMV website at https://www.flhsmv.gov/driver-licenses-id-cards/education-courses/dui-and-iid/licensed-dui-programs-florida/
•	Register for an in-person Victim Impact Panel through MADD at https://maddvip.org/listings/?search_location=Jacksonville%2C+FL&search_radius=100&search_lat=30.3297566&search_lng=-81.6591529&search_region= 
•	Remain crime-free

ENTRY OF REDUCED PLEA: At your next assigned court date, you (or your attorney, in the court’s discretion) will be permitted to enter a plea to an amended charge of Reckless Driving. Adjudication will be Withheld and you will be placed on a term of probation outlined below. 

SENTENCE AND PROBATION REQUIREMENTS: A person will be sentenced based on the requirements of a designated tier based upon the facts of the case. Adjudication will be withheld and probation will be for 6 to 12 months:

 `;

const agreementText2=`
1. DUI SCHOOL (ALL TIERS): Defendant will complete a substance abuse course conducted by a DUI program licensed by the department under s. 322.292, which shall include a psychosocial evaluation of the person, and successful completion of any substance abuse treatment recommendations by such program. 
2. VICTIM IMPACT PANEL (ALL TIERS): Defendant will complete a victim’s impact panel session, or a victim’s impact class. In-person classes through MADD are preferred unless good cause exists.
3. FINES & COSTS: Defendant will pay all fines and standard costs imposed by the judicial circuit, including a $100 cost of prosecution and a cost of supervision. There will be a $250 fine (Tiers 1 and 3) or $500 fine (Tier 2), $5 assessment to the Emergency Medical Services Trust Fund, and any attorney lien.
4. CHARITABLE DONATION (ALL TIERS): $250 donation to MADD.
5. IMPOUNDMENT (ALL TIERS): Upon commencement of the person’s participation in the program, all motor vehicles that are individually or jointly leased or owned and routinely operated by the person shall be impounded or immobilized for a period of 10 days. The State can waive this condition if the offender shows a hardship.
6. COMMUNITY SERVICE: Defendant must complete the following as administered by an approved program provider:
    a. Tiers 1 and 3: Fifty hours of community service; 
    b. Tier 2: Seventy-five hours of community service. 
7. INTERLOCK OR ALCOHOL/SUBSTANCE MONITORING: If the charge is related to the consumption of alcohol, after the impoundment or immobilization period, defendant will have installed, and must successfully use, an ignition interlock device approved by the department in accordance with Section 316.1938, or will substitute continuous alcohol monitoring (SCRAM). If the case involved the use of chemical or controlled substances he or she will agree to monitoring, including the use of a drug patch and random urinalysis: 
    a.Tier 1: Ninety (90) days with an interlock device. 45 days continuous SCRAM can be substituted. 
    b.Tier 2: One hundred eighty (180) days with an interlock device. 90 days of continuous SCRAM can be substituted.
    c.Tier 3: Drug Patch/Drug Monitoring for 90 days. Urinalysis at request of probation, SAO, or Court during entire period on probation (chemical or controlled substances)
8. DRUG FREE: Defendant may not possess or take any controlled substance as set forth in Chapter 893, Florida Statutes, unless the controlled substance was lawfully obtained from a practitioner or pursuant to a valid prescription; no alcohol is a condition if SCRAM is ordered.
9. RESTITUTION: Payment of any restitution owed to any person whose property has been damaged. Defendants will also cooperate with their insurance companies to assist payment for any damage to person or property. 
   COMPLETION OF PROBATION: If a person complies with their probation by successfully completing all special conditions and completing at least 50% of their probationary period they can apply for early termination of probation from the court.
   LIMITATION ON SEALING RECORDS: Defendants agree not to petition to seal their records for 5 years. 

I HEREBY ACCEPT AND ACKNOWLEDGE THE TERMS AND CONDITIONS BEFORE PROCEEDING.`;

*/

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        {!agreementAccepted ? (
          <>
            <div className="popup-header">
              <h2>DUI First Time Offender Program Agreement</h2>
            </div>
            <div className="popup-body">
            <div
              ref={agreementRef}
              onScroll={handleScroll}
              className="agreement-text"
            >
              <div className='agreementHeader'> <h3> TERMS AND CONDITIONS <br />
              STATE ATTORNEY’S OFFICE – 4TH JUDICIAL CIRCUIT </h3>
              
              </div>

     


   <h3> CAUTION: </h3> <span> These terms and conditions of the DUI First Time Offender Program are intended to outline the Program and are not intended to be legal advice. If you have any questions about your rights, adverse consequences, or the advantages or disadvantages of this program please consult a lawyer.  </span>
   <h3> INTENT OF PROGRAM:</h3>  <span> The DUI First Time Offender Program is intended for non-aggravated DUI offenses for offenders with little or no criminal history. The program contains many of the educational components and consequences related to a DUI offense without the resulting criminal conviction for DUI.  </span>
   <h3>  RESULT OF PROGRAM:</h3>  <span> An eligible offender will be permitted to enter a plea of guilty or no contest to the amended charge of Reckless Driving, and will be placed on probation to complete terms and conditions outlined below. <br />ALL ENTRIES OF PLEA AND SENTENCING ARE SUBJECT TO APPROVAL BY THE COURT.</span>



   <h3>ELIGIBILITY REQUIREMENTS FOR PROGRAM: </h3> <span>This program is designed for eligible first time DUI offenders charged with misdemeanor DUI contrary to Section 316.193, Florida Statutes. No person is entitled to participate in the program, and in its discretion, the State Attorney's Office may reject any person for consideration if it determines it is warranted under the facts and circumstances.  </span>


    <br />
              <h3>An offender will be ineligible for the program if he or she:</h3>
    <ol>
        <li>Has been charged with a prior alcohol-related or drug-related criminal traffic offense which resulted in an Adjudication of Guilt, a Withhold of Adjudication, or completion of a DUI diversionary program.</li>
        <li>Has a pending criminal charge (felony or misdemeanor) or prior felony conviction.</li>
        <li>Caused or contributed to the cause of a motor vehicle crash causing property damage or personal injury to another, unless the harmed party supports the defendant pleading to a reduced charge.</li>
        <li>Was, at the time of the offense, accompanied in the vehicle by a person under 18 years of age.</li>
        <li>Contemporaneously committed a separate offense involving dangerous driving, such as racing, or speed in excess of 50mph over the posted limit.</li>
        <li>Contemporaneously committed a separate offense unrelated to the driving offense, such as battery or resisting an officer.</li>
        <li>At the time of the offense did not have a valid driver’s license, or had a license or driving privilege which was canceled, suspended, or revoked.</li>
        <li>Is not a U.S. citizen.</li>
        <li>Had a Commercial Driver License (CDL).</li>
        <li>Had a blood alcohol level of 0.20 or more grams of alcohol per 100 milliliters of blood; or a breath-alcohol level of 0.20 or more grams of alcohol per 210 liters of breath.</li>
    </ol>

  
  

    <h3>Entry into Program</h3>
    <ol>
        <li>Within 45 days of your arrest,” you or your attorney must request a case screening through the SAO website and pay a $100 screening fee before your case is reviewed.</li>
        <li>Upon completion of the application and payment, the SAO will review your case for the program.</li>
        <li>If the SAO determines you are eligible for the program and accepts your application, <b>the SAO will notify you or your attorney.</b></li>
    </ol>

    <h3> You or your attorney must still appear at the next scheduled court date. </h3>
       
    <h3> ENTRY OF REDUCED PLEA:  </h3> <span>At your next assigned court date, you (or your attorney, in the court's discretion) will be permitted to enter a plea to an amended charge of Reckless Driving. Adjudication will be Withheld and you will be placed on a term of probation outlined below.  </span>

    <h3> SENTENCE AND PROBATION REQUIREMENTS:</h3>
    <span> A person will be sentenced based on the requirements of a designated tier based upon the facts of the case. Adjudication will be withheld and probation will be for 6 to 12 months:  </span>
            <div className="table-container">
              
                
              <table border="1">
                  <tr>
                                          <th>Tier One: <br />
                      Breath/Blood Result under .15
                      </th>
                                          <th>Tier Two: <br />
                      Breath/Blood Result .15-.20 or Alcohol Test Refusal
                      </th>
                                          <th>Tier Three: <br />
                      Controlled/Chemical Substances
                      </th>
                  </tr>
                  <tr>
                    <td>6 months of probation</td>
                    <td>12 months of probation</td>
                    <td>6-12 months of probation</td>
                  </tr>
                  <tr>
                    <td>DUI School</td>
                    <td>DUI School</td>
                    <td>DUI School</td>
                  </tr>
                  <tr>
                    <td>Victim Impact Panel</td>
                    <td>Victim Impact Panel</td>
                    <td>Victim Impact Panel</td>
                  </tr>

                  <tr>
                    <td>50 hours’ community service</td>
                    <td>75 hours’ community service</td>
                    <td>50 hours’ community service</td>
                  </tr>

                  <tr>
                    <td>10-day vehicle impound</td>
                    <td>10-day vehicle impound</td>
                    <td>10-day vehicle impound</td>
                  </tr>

                  <tr>
                    <td>90-day interlock or 45 days continuous SCRAM</td>
                    <td>180-day interlock or 90 days continuous SCRAM</td>
                    <td>Drug Patch for 90 days and/or Random Urinalysis if ordered</td>
                  </tr>

                  <tr>
                    <td>$250 fine + costs</td>
                    <td>$500 fine + costs</td>
                    <td>$250 fine + costs</td>
                  </tr>

                  <tr>
                    <td>$100 Cost of Prosecution</td>
                    <td>$100 Cost of Prosecution</td>
                    <td>$100 Cost of Prosecution</td>
                  </tr>

                  <tr>
                    <td>Restitution if applicable</td>
                    <td>Restitution if applicable</td>
                    <td>Restitution if applicable</td>
                  </tr>

                </table>

                

              </div>
          


          <div>  
              <ol> 
              <li> DUI SCHOOL (ALL TIERS): Defendant will complete a substance abuse course conducted by a DUI program licensed by the department under s. 322.292, which shall include a psychosocial evaluation of the person, and successful completion of any substance abuse treatment recommendations by such program.  </li>
              <li>VICTIM IMPACT PANEL (ALL TIERS): Defendant will complete a victim’s impact panel session, or a victim’s impact class. In-person classes through MADD are preferred unless good cause exists.  </li>
              <li> FINES & COSTS: Defendant will pay all fines and standard costs imposed by the judicial circuit, including a $100 cost of prosecution and a cost of supervision. There will be a $250 fine (Tiers 1 and 3) or $500 fine (Tier 2), $5 assessment to the Emergency Medical Services Trust Fund, and any attorney lien. </li>
              
              <li>IMPOUNDMENT (ALL TIERS): Upon commencement of the person’s participation in the program, all motor vehicles that are individually or jointly leased or owned and routinely operated by the person shall be impounded or immobilized for a period of 10 days. The State or Court can waive this condition if the offender meets the criteria of 316.193(6)(e), (f), (g), (h) or (i).</li>
              <li>COMMUNITY SERVICE: Defendant must complete the following as administered by an approved program provider; community service hours are not to be bought unless approved by the Court:</li>
              <ol type="a"> 
                <li>Tiers 1 and 3: Fifty hours of community service; </li>
                <li>Tier 2: Seventy-five hours of community service.  </li>
              </ol>
              <li>INTERLOCK OR ALCOHOL/SUBSTANCE MONITORING: If the charge is related to the consumption of alcohol, after the impoundment or immobilization period, defendant will have installed, and must successfully use, an ignition interlock device approved by the department in accordance with Section 316.1938, or will substitute continuous alcohol monitoring (SCRAM). If the case involved the use of chemical or controlled substances he or she will agree to monitoring, including the use of a drug patch and random urinalysis:  </li>
              <ol type="a"> 
                <li>Tier 1: Ninety (90) days with an interlock device. 45 days continuous SCRAM can be substituted.  </li>
                <li>Tier 2: One hundred eighty (180) days with an interlock device. 90 days of continuous SCRAM can be substituted. </li>
                <li>Tier 3: Drug Patch/Drug Monitoring for 90 days. Urinalysis at request of probation, SAO, or Court during entire period on probation (chemical or controlled substances) </li>
              </ol>
              <li>DRUG FREE: Defendant may not possess or take any controlled substance as set forth in Chapter 893, Florida Statutes, unless the controlled substance was lawfully obtained from a practitioner or pursuant to a valid prescription; no alcohol is a condition if SCRAM is ordered.  </li>
              <li>RESTITUTION: Payment of any restitution owed to any person whose property has been damaged. Defendants will also cooperate with their insurance companies to assist payment for any damage to person or property.   </li>

              </ol>
                        </div>

              <h3>COMPLETION OF PROBATION: </h3><span> If a person complies with their probation by successfully completing all special conditions and completing at least 50% of their probationary period they can apply for early termination of probation from the court.</span>
              <br />
              
              

             <h3> I HEREBY ACCEPT AND ACKNOWLEDGE THE TERMS AND CONDITIONS BEFORE PROCEEDING. </h3>

                
                
                

            </div>

            <div className="terms-acceptance">
              <label className="terms-checkbox-label">
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={handleTermsCheckboxChange}
                  className="terms-checkbox"
                />
                I have read, understood, and agree to the Terms and Conditions above
              </label>
            </div>

           
            <button
              onClick={handleAcceptAgreement}
              disabled={!isAgreementScrolled || !termsAccepted}
              className={isAgreementScrolled && termsAccepted ? '' : 'disabled'}
              
            >
              Next
            </button>
            </div>
          </>
        ) : (
          <>
            <div className="popup-header">
              <h2>DUI First Time Offender Program Eligibility</h2>
            </div>
            <div className="popup-body">
            <p>Select the boxes that you are eligible for review:</p>
            <div className="eligibility-list">
            <label>
              <input
                type="checkbox"
                name="noPriorOffense"
                checked={conditions.noPriorOffense}
                onChange={handleCheckboxChange}
              />
              I do not have a prior alcohol-related or drug-related criminal traffic offense which resulted in an adjudication of guilt, withhold of adjudication, or completion of DUI diversionary program
            </label>
            <label>
              <input
                type="checkbox"
                name="noPendingCharge"
                checked={conditions.noPendingCharge}
                onChange={handleCheckboxChange}
              />
              Other than my current DUI charge, I do not have another pending criminal charge
            </label>
            <label>
              <input
                type="checkbox"
                name="notFelon"
                checked={conditions.notFelon}
                onChange={handleCheckboxChange}
              />
              I am not a convicted felon
            </label>
            <label>
              <input
                type="checkbox"
                name="validLicense"
                checked={conditions.validLicense}
                onChange={handleCheckboxChange}
              />
              I had a valid driver's license at the time of my offense
            </label>
            <label>
              <input
                type="checkbox"
                name="noCDL"
                checked={conditions.noCDL}
                onChange={handleCheckboxChange}
              />
              I do not hold a CDL driver's license
            </label>
            <label>
              <input
                type="checkbox"
                name="duvalCounty"
                checked={conditions.duvalCounty}
                onChange={handleCheckboxChange}
              />
              My offense occurred in Duval, Clay, or Nassau County, Florida
            </label>
            <label>
              <input
                type="checkbox"
                name="noPlea"
                checked={conditions.noPlea}
                onChange={handleCheckboxChange}
              />
              I did not enter a plea of guilty or no contest at my first appearance
            </label>

            </div>
            {error && <p className="error">{error}</p>}
            <button onClick={handleSubmit}>Next</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Popup;